import type { PiniaPluginContext } from 'pinia'

const decodeBase64Value = (value: unknown): string => {
  if (typeof value !== 'string' || value.trim() === '') {
    return ''
  }
  try {
    return atob(value)
  } catch {
    return ''
  }
}

const getWindowValue = (key: string): string => {
  if (typeof window === 'undefined') {
    return ''
  }
  return decodeBase64Value((window as any)[key])
}

export function searchStorePlugin({ store }: PiniaPluginContext) {
  if (store.$id !== 'searchStore') return;

  const globalActiveCollectionId = getWindowValue('activeCollectionId')
  if (globalActiveCollectionId) {
    store['activeCollectionId'] = globalActiveCollectionId
  }

  const globalActiveCollectionName = getWindowValue('activeCollectionName')
  if (globalActiveCollectionName) {
    store['activeCollectionName'] = globalActiveCollectionName
  }

  let prevSearchResultActive = store['searchResultActive'];
  store.$subscribe((mutation, state) => {
    if(!prevSearchResultActive && state['searchResultActive']) {
      let contentPanes: any = document.querySelectorAll('[id=contentPane]');
      //remove all other content to display the search result in other pages.
      for(let i =0; i< contentPanes.length; i++)  {
        //if(!contentPanes[i].classList.contains('searchResultsPane')) {
            contentPanes[i].parentNode.removeChild(contentPanes[i]);
        //}
      }
    }
    prevSearchResultActive = state.searchResultActive;
  })
}
